import React, {useEffect} from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "../Components/Breadcrumb";
import bgImg from '../Images/contact-breadcrumb.webp'
import { motion } from "framer-motion";
import { products, additionalProduct } from "../Data";
import Cta from "../Components/Cta";
import SchemaMarkup from "../Components/SchemaMarkup";
import WebPageSchema from "../Schema/webPageSchema";
import createBreadcrumbSchema from "../Schema/breadcrumbSchema";
import ProductComparisonTable from "../Components/ProductComparisonTable";

const ProductsCommon=()=>{

const allProducts = [...products, ...additionalProduct];

useEffect(() => {
        document.title =
          "Wooden Packaging Products | Gurukrupa Wood Pvt. Ltd.";
    
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) {
          metaDesc.setAttribute(
            "content",
            "Explore wooden pallets, Euro pallets, wooden boxes, plywood boxes, crates and customised packaging for industrial and export applications."
          );
        }
    
        const canonical = document.querySelector("link[rel='canonical']");
      if (canonical) {
        canonical.setAttribute("href", "https://gurukrupawood.com/products");
      }
    
      const ogTitle = document.querySelector("meta[property='og:title']");
      if (ogTitle) {
        ogTitle.setAttribute(
          "content",
          "Wooden Packaging Products | Gurukrupa Wood Pvt. Ltd."
        );
      }
    
        const ogDesc = document.querySelector("meta[property='og:description']");
      if (ogDesc) {
        ogDesc.setAttribute(
          "content",
          "Explore wooden pallets, Euro pallets, wooden boxes, plywood boxes, crates and customised packaging for industrial and export applications."
        );
      }
    
      const ogUrl = document.querySelector("meta[property='og:url']");
      if (ogUrl) {
        ogUrl.setAttribute("content", "https://gurukrupawood.com/products");
      }
    
        const ogImage = document.querySelector("meta[property='og:image']");
      if (ogImage) {
        ogImage.setAttribute(
          "content",
          "https://gurukrupawood.com/about.webp"
        );
      }
    
        const twitterTitle = document.querySelector("meta[name='twitter:title']");
      if (twitterTitle) {
        twitterTitle.setAttribute(
          "content",
          "Wooden Packaging Products | Gurukrupa Wood Pvt. Ltd."
        );
      }
    
        const twitterDesc = document.querySelector(
        "meta[name='twitter:description']"
      );
      if (twitterDesc) {
        twitterDesc.setAttribute(
          "content",
          "Explore wooden pallets, Euro pallets, wooden boxes, plywood boxes, crates and customised packaging for industrial and export applications."
        );
      }
    
        const twitterImage = document.querySelector("meta[name='twitter:image']");
      if (twitterImage) {
        twitterImage.setAttribute(
          "content",
          "https://gurukrupawood.com/about.webp"
        );
      }
      }, []);

const schema = WebPageSchema({
    name: "Products of Gurukrupa Wood Pvt. Ltd.",
    url: "https://gurukrupawood.com/products",
    description:
      "We manufacture wooden pallets, Euro pallets, wooden boxes, plywood boxes, crates and customised packaging for industrial and export applications."
  });

const breadcrumbSchema = createBreadcrumbSchema([
  {
    name: "Home",
    url: "https://gurukrupawood.com/"
  },
  {
    name: "Products",
    url: "https://gurukrupawood.com/products"
  },
]);

    return(
        <>
         <SchemaMarkup data={schema} />
      <SchemaMarkup data={breadcrumbSchema} />
        
           <Breadcrumb
  pageName="Our Products"
  bgImage={bgImg}
/>

  {/**PRODUCTS GRID */}
    <section className="products-section container product-pg">

  {/* TOP */}
  <motion.div
    className="products-top"
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
    }}
    viewport={{ once: true, amount: 0.3 }}
  >

    <div className="products-heading">

      <motion.h3
        className="section-subheading"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1, duration: 0.5 }}
        viewport={{ once: true }}
      >
        OUR PRODUCTS
      </motion.h3>

      <motion.h2
        className="section-heading"
        initial={{ opacity: 0, y: 35 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.7 }}
        viewport={{ once: true }}
      >
        Strong. Durable. Reliable.<br /> Built for Every Industry.
      </motion.h2>

    </div>

  </motion.div>

  {/* PRODUCTS GRID */}
  <motion.div
    className="products-grid"
    variants={{
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.16,
        },
      },
    }}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.15 }}
  >

    {allProducts.map((item, i) => (
      <motion.div
        className="products-card"
        key={i}
        variants={{
          hidden: {
            opacity: 0,
            y: 60,
          },
          visible: {
            opacity: 1,
            y: 0,
          },
        }}
        transition={{
          duration: 0.75,
          ease: [0.22, 1, 0.36, 1],
        }}
        whileHover={{
          y: -10,
        }}
      >
        <Link to={`/products/${item.slug}`}>
        {/* IMAGE ZOOM */}
        <motion.div
          style={{ overflow: "hidden" }}
        >
          <motion.img
            src={item.img}
            alt={`${item.title} | Gurukrupa Wood Pvt. Ltd.`}
            whileHover={{
              scale: 1.08,
            }}
            transition={{ duration: 0.5 }}
          />
        </motion.div>

        {/* CONTENT */}
        <motion.div
          className="product-card"
          initial={{ opacity: 0.9 }}
          whileHover={{
            opacity: 1,
          }}
        >

          <h4 className="card-heading">{item.title}</h4>

          <p className="section-text">{item.desc}</p>

         <motion.a
  href={`/products/${item.slug}`}
  className="product-card-link"
  whileHover="hover"
  initial="rest"
>

  <motion.span
    className="know-more-text"
    variants={{
      rest: {
        opacity: 0,
        width: 0,
        marginRight: 0,
      },
      hover: {
        opacity: 1,
        width: "auto",
        marginRight: 4,
      },
    }}
    transition={{
      duration: 0.3,
    }}
  >
    Know More
  </motion.span>

  <motion.span
    className="arrow-icon"
    variants={{
      rest: {
        x: 0,
      },
      hover: {
        x: 8,
      },
    }}
    transition={{
      duration: 0.3,
    }}
  >
    →
  </motion.span>

</motion.a>

        </motion.div>
</Link>
      </motion.div>
    ))}

  </motion.div>

</section>

{/**TABLE SECTION */}

<ProductComparisonTable />

{/**CTA */}
<Cta />
        </>
    )
}
export default ProductsCommon;